export default __webpack_public_path__ + "static/media/destroyed_47@2x.b993b83b.png";